import { render, staticRenderFns } from "./stringListModal.vue?vue&type=template&id=63107a4c&scoped=true&"
import script from "./stringListModal.vue?vue&type=script&lang=ts&"
export * from "./stringListModal.vue?vue&type=script&lang=ts&"
import style0 from "./stringListModal.vue?vue&type=style&index=0&id=63107a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63107a4c",
  null
  
)

export default component.exports